import { EnumModel } from '@shared/models/enum-model';

export function enumToArray(enumObj: { [key: string]: any }, customDisplayNames?: { [key: string]: string }): EnumModel[] {
  return Object.keys(enumObj).map(
    (key) =>
      new EnumModel(key, enumObj[key] === 'true' ? true : enumObj[key] === 'false' ? false : enumObj[key], customDisplayNames?.[key] || key)
  );
}
